class PlpBannerManager extends HTMLElement {
  connectedCallback() {
    this._bannerEls = this._readBanners();
    if (!this._bannerEls.length) return;

    this._grid = document.querySelector('ul#product-grid');
    if (!this._grid) return;

    this._lastWidth = window.innerWidth;
    this.insert();

    document.addEventListener('productgrid:updated', this.insert.bind(this));
    document.addEventListener('plp:loadmore:done', this.insert.bind(this));
    window.addEventListener('resize', this._onResize.bind(this));
  }

  _readBanners() {
    var el = document.getElementById('plp-banner-data');
    if (!el) return [];
    var htmlStrings;
    try { htmlStrings = JSON.parse(el.textContent); } catch (e) { return []; }
    return htmlStrings.map(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector('.plp-banner-card');
    }).filter(Boolean);
  }

  _onResize() {
    var newWidth = window.innerWidth;
    if (newWidth === this._lastWidth) return;
    this._lastWidth = newWidth;
    clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(this.insert.bind(this), 150);
  }

  _isSorted() {
    var params = new URLSearchParams(window.location.search);
    return Array.from(params.keys()).some(function (key) {
      return key.startsWith('filter.') && key !== 'filter.p.m.custom.activate_look_product';
    });
  }

  insert() {
    var self = this;
    setTimeout(function () { self._doInsert(); }, 0);
  }

  _doInsert() {
    var self = this;
    var grid = document.querySelector('ul#product-grid');
    if (!grid || !this._bannerEls.length) return;
    this._grid = grid;

    grid.querySelectorAll('.plp-banner-card').forEach(function (el) { el.remove(); });

    var w = window.innerWidth;
    if (w >= 768 && w < 1024) return;

    if (this._isSorted()) return;

    var isMobile = w < 768;
    var products = Array.prototype.slice.call(
      grid.querySelectorAll('.grid__item:not(.plp-banner-card)')
    );

    var positions = isMobile
      ? this._mobilePositions(products.length)
      : this._desktopPositions(products.length);

    positions = positions.slice(0, self._bannerEls.length);

    positions.forEach(function (pos, i) {
      var bannerEl = self._bannerEls[i];
      var afterProduct = products[pos - 1];
      if (!afterProduct || !bannerEl) return;
      var clone = bannerEl.cloneNode(true);
      afterProduct.insertAdjacentElement('afterend', clone);
      var video = clone.querySelector('video');
      if (video) {
        video.muted = true;
        var playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(function () {});
        }
      }
    });
  }

  _mobilePositions(total) {
    var positions = [];
    for (var p = 4; p <= total; p += 8) positions.push(p);
    return positions;
  }

  _desktopPositions(total) {
    var positions = [];
    var p = 2, lastGap = 10;
    while (p <= total) {
      positions.push(p);
      if (lastGap === 6) { p += 10; lastGap = 10; }
      else               { p += 6;  lastGap = 6;  }
    }
    return positions;
  }
}

customElements.define('plp-banner-manager', PlpBannerManager);
